import { combineReducers } from 'redux'

import { appReducer } from './ducks/appDuck'
import { dashboardReducer } from './ducks/dashboardDuck'
import { employeeReducer } from './ducks/employeeDuck'
import { employeesReducer } from './ducks/employeesDuck'
import { essReducer } from './ducks/essDuck'
import { onboardingReducer } from './ducks/onboardingDuck'
import { payhistoryReducer } from './ducks/payHistoryDuck'
import { payrollReducer } from './ducks/payrollDuck'
import { payrollsReducer } from './ducks/payrollsDuck'
import { snackbarReducer } from './ducks/snackbarDuck'
import { widgetEssReducer } from './ducks/widgetEssDuck'
import { widgetFeedbackReducer } from './ducks/widgetFeedbackDuck'
import { widgetGlobalSearch } from './ducks/widgetGlobalSearchDuck'
import { widgetManageProfile } from './ducks/widgetManageProfileDuck'
import { widgetNewDownloadReducer } from './ducks/widgetNewDownloadDuck'
import { widgetSelectCompanyReducer } from './ducks/widgetSelectCompanyDuck'

export default combineReducers({
  app: appReducer,
  snackbar: snackbarReducer,
  dashboard: dashboardReducer,
  ess: essReducer,
  widgetFeedback: widgetFeedbackReducer,
  widgetNewDownload: widgetNewDownloadReducer,
  widgetSelectCompany: widgetSelectCompanyReducer,
  widgetEss: widgetEssReducer,
  employees: employeesReducer,
  employee: employeeReducer,
  onboarding: onboardingReducer,
  payhistory: payhistoryReducer,
  widgetManageProfile,
  widgetGlobalSearch,
  payrolls: payrollsReducer,
  payroll: payrollReducer,
})
